import { ReactNode, createContext } from "react";
import useDocument, { DocumentSignType, UserSigner } from "./hooks/useDocument";
import { SignerLinkItem } from "../gateways/DocumentGateway";

interface DocumentTypeContextProviderProps {
  children: ReactNode;
}

export interface DocumentTypeContextData {
  createDocument: (DocumentFile: any) => any;
  createSignUser: (base64Signature: any, photoSignerDocument?: any) => any;
  getDocumentSign: (documentId: string, suppressErrorToast?: boolean) => any;
  getDocuments: (page: number, documentName?: string, Loading?: boolean) => any;
  getSigners: (documentId: string, suppressErrorToast?: boolean) => any;
  createDocumentSignType: (document: DocumentSignType) => void;
  updateDocumentSignType: (document: DocumentSignType) => void;
  getSignersEdit: (documentId: string) => any;
  formValuesDocumentSign: DocumentSignType;
  setFormValuesDocumentSign: any;
  document: any;
  setDocument: any;
  formValuesSign: UserSigner;
  setFormValuesSign: any;
  infoSign: any;
  setInfoSign: any;
  signers: any;
  nameDocument: string;
  setNameDocument: any;
  tableDocuments: any[];
  signersEdit: [];
  idEditDocument: string;
  deleteDocumentSignType: (documentId: string) => any;
  downloadDocument: (documentId: string) => any;
  setIdEditDocument: any;
  totalDocuments: number;
  resendEmail: (documentId: string, emails: string[]) => any;
  collaborators: any;
  setCollaborators: any;
  setSignersEdit: any;
  tutorial: any, 
  setTutorial: any,
  getSignerLinks: (documentId: string) => Promise<SignerLinkItem[]>;
  resendEmailWithTokens: (documentId: string, signers: { email: string; name: string; encryptedToken: string; phone?: string | null; sendWhatsApp: boolean }[]) => Promise<void>;
}

const initialState: DocumentTypeContextData = {
  createDocument() {},
  getDocumentSign() {},
  createDocumentSignType() {},
  updateDocumentSignType() {},
  formValuesDocumentSign: {
    documentOwnerName: "",
    documentOwnerEmail: "",
    documentId: "",
    signerActionsRequest: [
      {
        signerEmail: "",
        signerName: "",
        userDocumentOwnerId: "",
        signType: 0,
        hasSigned: false,
        presencialSign: false,
        photoRequired: false,
        signatureLocations: [
          {
            positonX: 0,
            postionY: 0,
            pageNumber: 0,
            width: 0,
            height: 0,
          },
        ],
      },
    ],
    messageTitle: "",
    messageEmailBody: "",
  },
  setFormValuesDocumentSign() {},
  document: "",
  setDocument() {},
  formValuesSign: {
    signActionId: "",
    documentId: "",
    signerUserId: "",
    signature: "",
    name: "",
    nationalRegisterCode: "",
    signerIp: "",
    location: "",
    photo: "",
  },
  infoSign() {},
  getDocuments() {},
  setInfoSign: "",
  setFormValuesSign() {},
  createSignUser() {},
  getSigners(documentId: string) {},
  signers: "",
  nameDocument: "",
  setNameDocument() {},
  tableDocuments: [],
  getSignersEdit(documentId: string) {},
  signersEdit: [],
  idEditDocument: "",
  deleteDocumentSignType(documentId: string){},
  downloadDocument(documentId: string){},
  setIdEditDocument(){},
  totalDocuments: 0,
  resendEmail(documentId: string, emails: string[]){},
  collaborators: [],
  setCollaborators() {},
  setSignersEdit() {},
  tutorial: false, 
  setTutorial(){},
  async getSignerLinks() { return []; },
  async resendEmailWithTokens() {}
};

export const DocumentTypeContext =
  createContext<DocumentTypeContextData>(initialState);

export default function DocumentTypeContextProvider({
  children,
}: DocumentTypeContextProviderProps) {
  const {
    formValuesDocumentSign,
    setFormValuesDocumentSign,
    createDocument,
    createDocumentSignType,
    getDocumentSign,
    document,
    setDocument,
    formValuesSign,
    setFormValuesSign,
    createSignUser,
    infoSign,
    setInfoSign,
    getSigners,
    signers,
    getDocuments,
    nameDocument,
    setNameDocument,
    tableDocuments,
    getSignersEdit,
    signersEdit,
    updateDocumentSignType,
    idEditDocument,
    deleteDocumentSignType,
    setIdEditDocument,
    downloadDocument,
    totalDocuments,
    resendEmail,
    collaborators, 
    setCollaborators,
    setSignersEdit,
    tutorial, 
    setTutorial,
    getSignerLinks,
    resendEmailWithTokens
  } = useDocument();

  return (
    <DocumentTypeContext.Provider
      value={{
        formValuesDocumentSign,
        setFormValuesDocumentSign,
        createDocument,
        createDocumentSignType,
        getDocumentSign,
        document,
        setDocument,
        formValuesSign,
        setFormValuesSign,
        createSignUser,
        infoSign,
        setInfoSign,
        getSigners,
        signers,
        getDocuments,
        nameDocument,
        setNameDocument,
        tableDocuments,
        getSignersEdit,
        signersEdit,
        updateDocumentSignType,
        idEditDocument,
        deleteDocumentSignType,
        setIdEditDocument,
        downloadDocument,
        totalDocuments,
        resendEmail,
        collaborators, 
        setCollaborators,
        setSignersEdit,
        tutorial, 
        setTutorial,
        getSignerLinks,
        resendEmailWithTokens
      }}
    >
      {children}
    </DocumentTypeContext.Provider>
  );
}
